import * as Memberships from '../services/Memberships'

export const RECEIVE_GROUP_MEMBERSHIPS = 'RECEIVE_GROUP_MEMBERSHIPS'

function receiveGroupMemberships(state, memberships) {
  return {
    type: RECEIVE_GROUP_MEMBERSHIPS,
    memberships
  }
}

export const fetchGroupMemberships = (id) => (dispatch, getState) => {
  const state = getState()
  let subsidiaryId = state.currentUser.subsidiary
  Memberships.getActive(id, subsidiaryId).then((data) => dispatch(receiveGroupMemberships(state, data)))
}

export const updateMembership = (membership) => (dispatch, getState) => {
  return Memberships.update(membership)
}
